import React, { Component } from 'react';
import Logo from '../../../assets/images/loginLogoIcon.34b51808.png'
import LoginForm from '../../../components/loginForm';
import SubmittingBin from '../../../components/submitBinNumber';
import SubmittingNewPassword from '../../../components/submitNewPassword';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from "react-router-dom";
import Cookies from 'js-cookie';
import { isAuthintecated } from "../../../stores/actions";
import { Region } from '../../../utils/commonInterfaces';
import { getRegion } from '../../../components/regionWrapper';
import CountryFlag from '../../../components/countryFlag';

interface LoginProps extends RouteComponentProps<any> {
    phone_verified?: boolean
    pin_code_verified?: boolean,
    forgot_password?: boolean,
    loginPathName: any,
    isAuthintecated: any,
    authed?: boolean
}
class Login extends Component<LoginProps> {
    region: Region = getRegion() ?? Region.EG;

    componentDidMount() {
        if (this.region === Region.EG) {
            const user = Cookies.get('token') && true;
            if (user) {
                this.props.history.push('/')
            } else {
                this.props.isAuthintecated(false)
            }
            return;
        }

        // SE: backend manages cookies (HttpOnly), so auth comes from Redux
        if (this.props.authed) {
            this.props.history.push('/')
        } else {
            this.props.isAuthintecated(false)
        }
    }
    render() {
        const { phone_verified, pin_code_verified, forgot_password } = this.props;
        const isForgot = !phone_verified && !pin_code_verified && !!forgot_password;
        const isOtp = !!phone_verified && !pin_code_verified;
        const title = isForgot ? 'Reset password' : isOtp ? 'Verification code' : 'Welcome back';
        const subtitle = isForgot
            ? 'Enter your phone number and choose a new password'
            : isOtp
                ? 'Enter the 5-digit code sent to your phone'
                : 'Sign in to continue to operations';
        // Layout steps
        const Login_layouts = !phone_verified && !pin_code_verified && !forgot_password ? <LoginForm />
            : phone_verified && !pin_code_verified && !forgot_password ? <SubmittingBin login />
                : !phone_verified && !pin_code_verified && forgot_password ? <SubmittingNewPassword /> :
                    phone_verified && !pin_code_verified && forgot_password ? <SubmittingBin resetPassword /> : null;
        const isSaudi = this.region === Region.SE;
        const regionName = isSaudi ? 'Saudi Arabia' : 'Egypt';
        const opsName = isSaudi ? 'Saudi' : 'Egypt';
        return (
            <div className='main'>
                <aside className="login-brand">
                    <div className="login-brand__mark">
                        <img className='logo' src={Logo} alt='NowPay' />
                    </div>
                    <div className="login-brand__region">
                        <CountryFlag
                            code={isSaudi ? 'sa' : 'eg'}
                            className="login-brand__flag"
                            width={28}
                            height={20}
                        />
                        <span>{regionName}</span>
                    </div>
                    <h2 className="login-brand__title">{opsName} Operations</h2>
                    <p className="login-brand__copy">
                        Manage users, companies, requests and collections from one secure workspace.
                    </p>
                </aside>
                <div className="container">
                    <div className="login-panel">
                        <h1 className="login-title">{title}</h1>
                        <p className="login-subtitle">{subtitle}</p>
                        {Login_layouts}
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state: any) => ({
    phone_verified: state.auth.phone_verified,
    pin_code_verified: state.auth.pin_code_verified,
    forgot_password: state.auth.forgot_password,
    authed: state.auth.authed,
})
export default withRouter(connect(mapStateToProps, { isAuthintecated })(Login))
